import { Delete } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import DriverPriceService from "app/apis/Goeasy/Driver/DriverPriceService";
import BreadCrumbs from "app/components/Breadcrumbs/Breadcrumbs";
import { PrimaryButton } from "app/components/Buttons/Button";
import AddNewDriver from "app/components/Dialog/AddNewDriver";
import { ErrorToaster, SuccessToaster } from "app/components/Toaster/Toaster";
import Layout from "app/layout/Layout";
import colors from "app/styles/colors";
import React, { useEffect, useState } from "react";

function DriverManagement() {
  const [dataList, setDataList] = useState([]);
  const [listLoader, setListLoader] = useState(true);
  const [selectedData, setSelectedData] = useState();
  const [showDialog, setShowDialog] = useState(false);

  const getAllDrivers = async () => {
    try {
      setShowDialog(false);
      let { data, success } = await DriverPriceService.getDriver();
      if (success) {
        setDataList(data);
      }
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setListLoader(false);
    }
  };

  const deleteItem = async (id) => {
    try {
      let { success } = await DriverPriceService.deleteDriver({ id });
      if (success) {
        getAllDrivers();
      }
      SuccessToaster("Driver deleted successfully");
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getAllDrivers();
  }, []);
  return (
    <Layout>
      <AddNewDriver
        handleClose={() => setShowDialog(false)}
        open={showDialog}
        handleSubmitFunc={getAllDrivers}
      />
      <Box
        sx={{ backgroundColor: colors.lightGray, p: 3, borderRadius: "12px" }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ bgcolor: colors.white, p: 2, borderRadius: "12px" }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              Driver Management
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage="Driver Management" />
          </Grid>
        </Grid>

        <Box
          sx={{
            mt: 2,
            bgcolor: colors.white,
            p: 2,
            borderRadius: 4,
            textAlign: "right",
          }}
        >
          <PrimaryButton
            onClick={() => setShowDialog(true)}
            title="Add New Driver"
          />
        </Box>

        <Box sx={{ mt: 2, bgcolor: colors.white, p: 2, borderRadius: 4 }}>
          {listLoader ? (
            <Box sx={{ textAlign: "center" }}>
              <CircularProgress color="success" />
            </Box>
          ) : (
            <>
              <TableContainer component={Paper} sx={{ my: 2 }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow sx={{ bgcolor: colors.primary }}>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Name
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Contact
                      </TableCell>

                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataList?.map((row, index) => (
                      <TableRow
                        sx={{
                          bgcolor: index % 2 ? colors.lightGray : "white",
                        }}
                        key={row.name}
                      >
                        <TableCell>{row?.name ?? "-"}</TableCell>
                        <TableCell>{row?.contact_no ?? "-"}</TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex" }}>
                            <IconButton
                              onClick={() => deleteItem(row?.id)}
                              size="small"
                            >
                              <Delete color="error" />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </Box>
      </Box>
    </Layout>
  );
}

export default DriverManagement;
